import OutlinedInput, {
  outlinedInputClasses,
} from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';

import type { TextAreaResize } from 'ui/text-area/text-area.types';

interface TextAreaControlOwnerState {
  textAreaResize: TextAreaResize;
}

const shouldForwardProp = (prop: PropertyKey) => prop !== 'textAreaResize';

export const TextAreaControl = styled(OutlinedInput, {
  shouldForwardProp,
})<TextAreaControlOwnerState>(({ theme, textAreaResize }) => ({
  [`& .${outlinedInputClasses.input}`]: {
    resize: textAreaResize,
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.palette.secondary.light} transparent`,
  },
}));
